import { NO_DATA_PLACEHOLDER } from '@occc/ui-design-system';


import {
  ExternalLoyaltyManualOffer,
  External_Loyalty_Manual_Offer_Activate_Status,
  External_Loyalty_Manual_Offer_Status,
} from '../../tobacco-api-offers.types';

export type RowActionType = 'create' | 'delete';

export type RowAction = {
  label: string;
  color: 'primary' | 'warning' | 'inherit';
  disabled?: boolean;
  actionType: RowActionType;
} | null;

export const getRowAction = (offer: ExternalLoyaltyManualOffer): RowAction => {
  if (offer.isArchived) {
    return { label: 'Archived', color: 'inherit', actionType: 'delete', disabled: true };
  }

  const isDeleteable =
    (offer.status === External_Loyalty_Manual_Offer_Status.Created ||
      offer.status === External_Loyalty_Manual_Offer_Status.ManualUpdated) &&
    offer.inActivate &&
    offer.activateStatus === External_Loyalty_Manual_Offer_Activate_Status.Published;

  if (isDeleteable) {
    return { label: 'Delete', color: 'warning', actionType: 'delete' };
  }

  if (!offer.inActivate && offer.status === External_Loyalty_Manual_Offer_Status.Ready) {
    return { label: 'Create', color: 'primary', actionType: 'create' };
  }

  return null;
};

export const VISIBLE_STATES_COUNT = 8;
export const TABLE_VISIBLE_STATES_COUNT = 3;

export const formatStates = (states: string[], visibleCount = VISIBLE_STATES_COUNT) => {
  if (states.length === 0) return NO_DATA_PLACEHOLDER;
  const display = states.slice(0, visibleCount).join(', ');
  return states.length > visibleCount ? `${display},...` : display;
};
